var React = require('react');

function PolandRound (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"poland-round"),React.createElement("desc",{"key":1},"Created with Sketch."),React.createElement("g",{"id":"Page-1","stroke":"none","strokeWidth":"1","fill":"none","fillRule":"evenodd","key":2},React.createElement("g",{"id":"poland-round","fillRule":"nonzero"},[React.createElement("path",{"d":"M8,0 C12.418278,0 16,3.581722 16,8 C16,12.418278 12.418278,16 8,16 C3.581722,16 0,12.418278 0,8 C0,3.581722 3.581722,0 8,0 Z","id":"Path","fill":"#FFFFFF","key":0}),React.createElement("path",{"d":"M16,8 C16,12.418278 12.418278,16 8,16 C3.66508574,16 0.135457134,12.5521622 0.00380682464,8.24917933 L0,8 L16,8 Z","id":"Path","fill":"#DA153C","key":1})]))]);
}

PolandRound.defaultProps = {"width":"16px","height":"16px","viewBox":"0 0 16 16","version":"1.1"};

module.exports = PolandRound;

PolandRound.default = PolandRound;
